import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { ControlInputContainer } from '../../../internal/components/ControlInputContainer';
import { generateDataTestId } from '../../../internal/utils';
import { useDeviceType } from '../../../responsive';
import { getStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SwitchComponent = /*#__PURE__*/React.forwardRef(function Switch(props, ref) {
  const {
    disabled,
    invalid,
    label,
    dataTestId
  } = props;
  const deviceType = useDeviceType();
  const styles = getStyles(deviceType);
  return /*#__PURE__*/_jsxs(ControlInputContainer, _objectSpread(_objectSpread({}, props), {}, {
    type: "checkbox",
    className: clsx(styles['switch'], disabled && styles['disabled'], invalid && styles['invalid']),
    ref: ref,
    children: [/*#__PURE__*/_jsx("span", {
      className: styles['indicator']
    }), label && /*#__PURE__*/_jsx("span", {
      className: styles['label'],
      "data-testid": generateDataTestId(dataTestId, ['label']),
      children: label
    })]
  }));
});

/**
 * Компонент простого чекбокса с лейблом
 *
 * На телефоне имеет блочный дизайн и чекбокс справа
 *
 * [Ссылка на макет](https://www.figma.com/design/0qasJktEnn9HVMKdHCVOG0/%F0%9F%8C%90-Switch)
 *
 * @export
 * @param {ICheckboxProps} props
 * @returns
 */
export const Switch = /*#__PURE__*/React.memo(SwitchComponent);